import React, { FC } from 'react';
import { Button } from 'components/ui';
import { useHistory } from 'react-router-dom';
import image from 'assets/img/404_image.svg';
import styles from './Page404.module.scss';

const Page404: FC = () => {
  const history = useHistory();
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <img
          className={styles.image}
          src={image}
          alt='Happy man on beach with laptop'
          width='314'
          height='293'
        />
        <h2 className={styles.title}>404: Page not found</h2>
        <p className={styles.text}>
          It seems this page booked a vacation and we can&apos;t find it at the moment.
          <br />
          Please try again later or contact our support.
        </p>
        <Button className={styles.button} onClick={() => history.goBack()} inline>
          Go back
        </Button>
      </div>
    </div>
  );
};

export default Page404;
